// extracted by mini-css-extract-plugin
export default {"textarea":"qIGk8b"};